import { FunctionFactory } from 'survey-core';

enum Goals {
  BuildMuscleAndLoseFat = "Lose Fat Most Important",
  BuildMuscle = "Build Muscle Most Important",
  LoseFat = "Lose Weight",
}

const goalsQuestion = {
  name: "goals",
  title:
    'What is your main <div class="highlight">fitness goal</div> right now?',
  type: "radiogroup",
  description:
    "This helps tailor our science-backed recommendations to your goal.",
  choices: [
    {
      value: Goals.LoseFat,
      text: "<div class='icon-button'><div>🔥</div><div>I'm focused on losing weight</div></div>",
    },
    {
      value: Goals.BuildMuscle,
      text: "<div class='icon-button'><div>💪</div><div>Building muscle is more important than losing fat</div></div>",
    },
    {
      value: Goals.BuildMuscleAndLoseFat,
      text: "<div class='icon-button'><div>🔄</div><div>I’d like to lose fat while I build some muscle</div></div>",
    },
  ],
  isRequired: true,
};

function renderGoalsText(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as Goals) {
    case Goals.LoseFat:
      return "lose weight";
    case Goals.BuildMuscle:
      return "gain muscle";
    case Goals.BuildMuscleAndLoseFat:
      return "build muscle and lose fat";
  }
}

const goalsTextExpression = {
  name: "goalsText",
  expression: "renderGoalsText({goals})",
};

FunctionFactory.Instance.register("renderGoalsText", renderGoalsText);

export { Goals, goalsQuestion, goalsTextExpression };

